import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper'; ////actualizacion nodejs
import Table from '@mui/material/Table'; //actualizacion nodejs
import TableBody from '@mui/material/TableBody'; //act nodejs
import TableCell from '@mui/material/TableCell'; //actualziacion nodejs
import TableContainer from '@mui/material/TableContainer'; //actualziacion nodejs
import TableHead from '@mui/material/TableHead'; //ACT NODEJS
import TablePagination from '@mui/material/TablePagination'; //actualziacion nodejs
import TableRow from '@mui/material/TableRow'; //actualziacion nodejs
import TextField from '@mui/material/TextField'; //actualizacion nodejs
import MenuItem from '@mui/material/MenuItem'; // act nodejs
import Typography from '@mui/material/Typography'; //actualizacion nodejs
import { useSelector } from 'react-redux';
import Clientes from '../../components/Clientes';


export default function StickyHeadTable() {
  const hasWindow = typeof window !== 'undefined';
  function getWindowDimensions() {
    const width = hasWindow ? window.innerWidth : null;
    const height = hasWindow ? window.innerHeight : null;
    return {
      width,
      height,
    };
  }

  const [clientes, setClientes] = useState([]);
  const {syncs} =  useSelector((state)=>{ return state });
  const [currencies, setCurrencies] = useState([]);

  useEffect(() => {
    let data = syncs.clientes;
    setClientes(data);
    let sucursales = syncs.vendedor.VKBUR;
    let tmp = [];
    tmp.push("Todas");
    setCurrencies(tmp.concat(sucursales));
  }, []);

  const useStyles = styled({
    root: {
      width: '100%',
      maxHeight: getWindowDimensions().height -100
    },
    container: {
      marginTop: 20,
      maxHeight: getWindowDimensions().height - 200,
    },
  });
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(4);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const [currency, setCurrency] = useState('Todas');

  const handleChange = (event) => {
    setCurrency(event.target.value);
  };

  useEffect(() => {
    let data = syncs.clientes;
    let listaClientes;
    if (currency !== "Todas"){
      listaClientes = data.filter(element => element.VKBUR === currency);
    }else{
      listaClientes = data;
    }
    setClientes(listaClientes);
  }, [currency]);

  return (
    <Paper className={classes.root}>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table" key="tabla clientes">
          <TableHead>
            <TableRow>
              <TableCell align={"center"} >
                <div style={{display:"flex", justifyContent:"space-around"}}>
                  <div>
                    <TextField
                      id="standard-select-currency"
                      select
                      helperText="Selecciona una sucursal"
                      value={currency}
                      onChange={handleChange}
                      label="Filtro de sucursal"
                    >
                      {currencies.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                        ))
                      }
                    </TextField>
                  </div>
                  <div><Typography variant="h4">Lista de clientes </Typography></div>
                  <div>
                    <TextField
                      id="standard-select-currency"
                      select
                      helperText="Selecciona una sucursal"
                      value={currency}
                      onChange={handleChange}
                      label="Filtro de sucursal"
                    >
                      {currencies.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                        ))
                      }
                    </TextField>
                  </div>
                </div>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {clientes.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
              return (
                <Clientes data={row} index={index} key={"cliente" + index}/>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <div style={{height:10}}/>
      <TablePagination
        rowsPerPageOptions={[4]}
        component="div"
        count={clientes.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}